import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthModal } from './components/AuthModal';
import { AuthProvider } from './components/AuthProvider';
import { ContactFormProvider } from './components/ContactFormProvider';
import { LanguageProvider } from './components/LanguageProvider';
import { QuoteCartProvider } from './components/QuoteCartProvider';
import { ScrollAnimations } from './components/ScrollAnimations';
import { ScrollManager } from './components/ScrollManager';
import Badges from './pages/badges';
import Bookmarks from './pages/bookmarks';
import Brochures from './pages/brochures';
import BusinessCards from './pages/business-cards';
import Calendars from './pages/calendars';
import Catalogues from './pages/catalogues';
import Certificates from './pages/certificates';
import CoatedPaperBags from './pages/coated-paper-bags';
import EnvelopesReadyMade from './pages/envelopes-ready-made';
import EnvelopesCustomized from './pages/envelopes-customized';
import FlyerProduct from './pages/flyer-product';
import Folders from './pages/folders';
import Home from './pages/index';
import IdCards from './pages/id-cards';
import Invitations from './pages/invitations';
import KraftPaperBags from './pages/kraft-paper-bags';
import Leaflets from './pages/leaflets';
import Letterheads from './pages/letterheads';
import Menus from './pages/menus';
import MenusSingle from './pages/menus-single';
import MenusFolded from './pages/menus-folded';
import MenusTent from './pages/menus-tent';
import Agendas from './pages/agendas';
import Notebooks from './pages/notebooks';
import Postcards from './pages/postcards';
import Posters from './pages/posters';
import PrescriptionPads from './pages/prescription-pads';
import Profile from './pages/profile';
import SelfCarbonNotebooks from './pages/self-carbon-notebooks';

function Routing() {
  return (
    <BrowserRouter>
      <ScrollManager />
      <LanguageProvider>
        <AuthProvider>
          <ContactFormProvider>
            <QuoteCartProvider>
              <ScrollAnimations />
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/agendas" element={<Agendas />} />
                <Route path="/badges" element={<Badges />} />
                <Route path="/bookmarks" element={<Bookmarks />} />
                <Route path="/brochures" element={<Brochures />} />
                <Route path="/business-cards" element={<BusinessCards />} />
                <Route path="/calendars" element={<Calendars />} />
                <Route path="/catalogues" element={<Catalogues />} />
                <Route path="/certificates" element={<Certificates />} />
                <Route path="/coated-paper-bags" element={<CoatedPaperBags />} />
                <Route path="/envelopes-ready-made" element={<EnvelopesReadyMade />} />
                <Route path="/envelopes-customized" element={<EnvelopesCustomized />} />
                <Route path="/flyer-product" element={<FlyerProduct />} />
                <Route path="/folders" element={<Folders />} />
                <Route path="/id-cards" element={<IdCards />} />
                <Route path="/invitations" element={<Invitations />} />
                <Route path="/kraft-paper-bags" element={<KraftPaperBags />} />
                <Route path="/leaflets" element={<Leaflets />} />
                <Route path="/letterheads" element={<Letterheads />} />
                <Route path="/menus" element={<Menus />} />
                <Route path="/menus-single" element={<MenusSingle />} />
                <Route path="/menus-folded" element={<MenusFolded />} />
                <Route path="/menus-tent" element={<MenusTent />} />
                <Route path="/notebooks" element={<Notebooks />} />
                <Route path="/postcards" element={<Postcards />} />
                <Route path="/posters" element={<Posters />} />
                <Route path="/prescription-pads" element={<PrescriptionPads />} />
                <Route path="/profile" element={<Profile />} />
                <Route path="/self-carbon-notebooks" element={<SelfCarbonNotebooks />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
              <AuthModal />
            </QuoteCartProvider>
          </ContactFormProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default Routing;
